var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spare-table" }, [
    _c("div", { staticClass: "spare-table-header" }, [
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { inline: "", "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "料号：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入料号", clearable: "" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchPartList.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.formData.CODE,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "CODE", $$v)
                      },
                      expression: "formData.CODE"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品名：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品号", clearable: "" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchPartList.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.formData.NAME,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "NAME", $$v)
                      },
                      expression: "formData.NAME"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "spare-table-body" },
      [
        _c(
          "vxe-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading"
              }
            ],
            ref: "xTable",
            attrs: {
              border: "",
              resizable: "",
              height: "100%",
              data: _vm.tableData,
              size: "medium",
              align: "center",
              "highlight-hover-row": "",
              "highlight-current-row": "",
              "show-overflow": "",
              "auto-resize": "",
              "keep-source": "",
              stripe: ""
            }
          },
          [
            _c("vxe-table-column", { attrs: { type: "seq", width: "60" } }),
            _c("vxe-table-column", { attrs: { field: "Code", title: "料号" } }),
            _c("vxe-table-column", {
              attrs: { field: "Name", title: "品名", width: 250 }
            }),
            _c("vxe-table-column", {
              attrs: { field: "Description", title: "规格描述" }
            }),
            _c("vxe-table-column", {
              attrs: {
                title: _vm.$t("as_src.tb_og"),
                align: "center",
                fixed: "right",
                width: "180"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.cellInsertClick(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s("插入") + " ")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "spare-table-footer" },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.formData.Page,
            "page-size": _vm.formData.Limit,
            "page-sizes": [15, 25, 35, 45],
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalPage
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }